<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="share-modal u-window">
            <div class="u-btn close" @click="destroyElement">X</div>
            <div class="share-img"></div>
            <div class="txt">
                <p>亲爱的玩家，邀请你的老朋友回归梦三国，一起并肩作战，</p>
                <p>即可领取炫酷武器、封灵玉等豪华老友回归奖励。</p>
                <p>快去邀请你的好友，驰骋沙场，共话三国！</p>
            </div>
            <div class="u-btn share copy" data-clipboard-action="copy" :data-clipboard-text="text.replace('${url}',url)" @click="copy"></div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'share-modal',
    data : function (){
        return {
            visible : false,
            code : '',
            text : this.$global.domain + '?code=' + this.code,
            url : '',
        }
    },
    created(){
        this.render();
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },       
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              _this.$toast("复制成功");
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },
        render (){
            let _this = this;
            _this.$axios.post(_this.$global.ajax_url_map.short_url,{
                url : _this.$global.domain,
            })
            .then(res => {
                if(res.data.code == 0 && res.data.data.koudai){
                    _this.text = res.data.data.koudai + res.data.data.surl;
                }
                else{
                    _this.text = _this.$global.domain + '?code=' + _this.code;
                }
            });
        },        
    },    
}
</script>

<style>
    .share-img{
        width: 909px;
        height: 663px;
        margin: 0 0 20px 225px;
        background-image: url(../../images/share-img.png);
    }

    .share-modal .txt{
        line-height: 1.8;
        margin-top: -55px;
        margin-bottom: 15px;
        font-size: 18px;
        color: #fff2d6;
        text-align: center;
    }

    .share-modal .u-btn.close{
        position: absolute;
        top: 165px;
        right: 225px;
        width: 66px;
        height: 66px;
        font-size: 0;
        color: transparent;
        background-image: url(../../images/btn-close-share.png);
    }

    .share-modal .u-btn.close:hover{
        background-image: url(../../images/btn-close-share_hover.png);
    }

    .share-modal .u-btn.share{
        width: 257px;
        height: 60px;
        margin: 0 auto;
        background-image: url(../../images/btn-share.png);
    }

    .share-modal .u-btn.share:hover{
        background-image: url(../../images/btn-share_hover.png);
    }

    @media screen and (max-device-width: 1024px){
    .share-modal .txt{
        font-size: 24px;
    }

    .share-modal .u-btn.close{
        position: absolute;
        top: 105%;
        left: 50%;
        width: 66px;
        height: 66px;
        font-size: 0;
        color: transparent;
        background-image: url(../../images/btn-close-share.png);
        transform: translateX(-50%);
    }        
    }
</style>


// WEBPACK FOOTER //
// src/components/Share/share.vue